<div class="container-fluid">
  <div>
    <div class="content">

      <div class="pull-right">
        <div>
          <button pButton (click)="addCategory()" class="p-button-raised"
            label="{{'bikeshop.rentals.category.add_category' | translate}}"
            style="width: 200px;"></button>
        </div>
      </div>

      <div class="category-header">
        <div>{{ 'bikeshop.rentals.category.category' | translate }}</div>
        <div>{{ 'bikeshop.rentals.category.force_selection' | translate }}</div>
      </div>
      <div *ngIf="loading && categories.length === 0"
        style="margin-top: 16px;margin-bottom: 16px;display: flex;justify-content: center;">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
        </p-progressSpinner>
      </div>
      <div *ngFor="let category of categories">
        <div class="category-row">
          <div>{{category.categoryName}}</div>
          <div>{{category.forceSelection ? ('general.yes' | translate) : ('general.no' | translate) }}</div>
          <div class="action">
            <span class="fa hubtiger-edit" (click)="editCategory(category)"></span>
          </div>
        </div>
      </div>

      <div *ngIf="!loading && categories.length === 0" class="no-categories">
        {{ 'bikeshop.rentals.categories.no_product_categories' | translate }}
      </div>

    </div>
  </div>
